<cdx-slotted-modal (close)="close()" size="large">
	<section modal-content>
		<h1 i18n="@@payments-list-payWith">Pay with</h1>
		<ul>
			<li *ngFor="let instrument of savedInstruments$ | async; trackBy: trackByFn">
				<button
					class="paymentList-selectCard"
					(click)="handleSavedInstrumentClick(instrument)"
					[attr.aria-label]="'Switch to card ending ' + instrument.cardSuffix"
					[cdxTrackEvent]="{
						event: trackingEvent.NotificationEvent,
						type: notificationType.Modal,
						name: 'select payment type',
						value: 'CC'
					}"
				>
					<cdx-payment-instrument
						[cardScheme]="instrument.scheme"
						[cardSuffix]="instrument.cardSuffix"
						[expiryYear]="instrument.expiryYear"
						[expiryMonth]="instrument.expiryMonth"
						[isExpired]="instrument.expired"
					>
						<div *ngIf="instrument.isUsedForDeliverySaver" class="paymentList-usedOnDeliverySaver" cdx-payment-instrument-infoBadge>
							Delivery saver subscription
						</div>
						<button
							class="paymentList-actions"
							cdx-payment-instrument-actions
							i18n="@@payments-instrument-delete"
							cdxButton
							fillStyle="link"
							(click)="delete($event, instrument.id)"
							[cdxTrackEvent]="{
								event: trackingEvent.NotificationEvent,
								type: notificationType.Modal,
								name: 'delete card'
							}"
						>
							Delete
						</button>
					</cdx-payment-instrument>
				</button>
			</li>
			<li *ngIf="directDebitEnabled$ | async">
				<button
					(click)="handleDirectDebitClick()"
					[cdxTrackEvent]="{
						event: trackingEvent.NotificationEvent,
						type: notificationType.Modal,
						name: 'select payment type',
						value: 'DD'
					}"
				>
					<wnz-payment-direct-debit></wnz-payment-direct-debit>
				</button>
			</li>
			<li>
				<button
					(click)="addNew()"
					class="paymentList-addNewCard"
					[cdxTrackEvent]="{
						event: trackingEvent.NotificationEvent,
						type: notificationType.Modal,
						name: 'add new card'
					}"
				>
					<cdx-svg-icon size="small" name="plus" fill="dark"></cdx-svg-icon>
					{{ addNewCardDescription }}
				</button>
			</li>
		</ul>
	</section>
</cdx-slotted-modal>
